import { render, staticRenderFns } from "./testItemDetails.vue?vue&type=template&id=383d3e0c&scoped=true"
import script from "./testItemDetails.vue?vue&type=script&lang=js"
export * from "./testItemDetails.vue?vue&type=script&lang=js"
import style0 from "./testItemDetails.vue?vue&type=style&index=0&id=383d3e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d3e0c",
  null
  
)

export default component.exports